import template from './toolbar.html';
import controller from './toolbar.controller';
import './toolbar.scss';

let toolbarComponent = {
  bindings: {},
  template,
  controller
};

export default toolbarComponent;



// WEBPACK FOOTER //
// ./client/app/common/layout/toolbar/toolbar.component.js